import { render } from "./MessageDatatable.vue?vue&type=template&id=311f4ef6"
import script from "./MessageDatatable.vue?vue&type=script&lang=js"
export * from "./MessageDatatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__